import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUserId = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.72 5.092h2.011c2.606 0 4.223 1.84 4.223 4.445v7.026c0 2.597-1.617 4.438-4.222 4.438H8.276c-2.605 0-4.23-1.841-4.23-4.438V9.537c0-2.604 1.633-4.445 4.23-4.445h2.013"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.343 6.804-1.186.596a.34.34 0 0 1-.304 0l-1.194-.596a.68.68 0 0 1-.375-.607v-2.24c0-.528.428-.957.958-.957h1.516c.53 0 .959.43.959.957V6.2c0 .256-.145.49-.374.605M13.749 11.67a1.75 1.75 0 1 1-3.499 0 1.75 1.75 0 0 1 3.499 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.262 17.244c0-.895.705-2.008 2.738-2.008s2.739 1.106 2.739 2"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUserId);
export default ForwardRef;
